<template>
    <div class="par_wrap">
        <p class="back_box" @click="back()">
          <img src="../../../static/images/back.png" alt="">
          {{langtrans().fhssyy[languageIndex]}}</p>
        <div class="box">
            <h2>{{langtrans().czkkbb[languageIndex]}}</h2>
            <ParheaderVue v-if="this.$route.query.typeId != 800" :caseid="caseid" :token="token"/>
           <div class="swi_box">
                <div class="bottom_box">
                    <router-view></router-view>
                </div>
            </div>
            <div class="jiedianBox">
				<div class="det_box">
					<p v-for="(v,ind) in stepdata" :key="ind" v-if="v.dict.parentId===0">1
						<b>{{languageIndex == 0 ? v.dict.name : v.dict.nameEn}}{{langtrans().jyffwq[languageIndex]}}</b>
					</p>
				</div>
				<div class="list" v-for="(item,index) in stepdata" v-if="index != 0">
					<div class="yes">
						<div class="top">
							<p class="icon">{{languageIndex == 0 ?  item.dict.name : item.dict.nameEn}}</p>
						</div>	
						<div class="box1">
							<p>{{langtrans().qjtjjd[languageIndex]}}</p>
							<ul>
								<li v-for="(item,index) in item.solutionSvrPointList">{{index + 1}}、{{languageIndex==0? setTxt(item.description,'zh'):setTxt(item.description,'en')}}</li>
							</ul>
						</div>
						<div class="box1">
							<p>{{langtrans().cczzzs[languageIndex]}}</p>
							<ul>
								<li>{{languageIndex==0? setTxt(item.obj.description,'zh'):setTxt(item.obj.description,'en')}}</li>
							</ul>
						</div>
						<div class="box1">
							<p>{{langtrans().xxgdcs[languageIndex]}}</p>
							<ul class="addfujian">
								<li v-for="item in imglist[index - 1].list"  v-if="item.url">
									<span>{{item.description || 'no name'}}</span> <a :href="item.url" class="delete" :download='item.url' target="_blank">[{{langtrans().xzz[languageIndex]}}]</a>									
								</li>
							</ul>
						</div>
					</div>
				</div>				
			</div>
			<div class="baojia">
				<p><b>{{langtrans().jybjjj[languageIndex]}}</b></p>
				<ul>
					<h3>A{{langtrans().bjjj[languageIndex]}}</h3>					
					<h3 v-if="this.$route.query.typeId != 800">{{langtrans().ztbtbj[languageIndex]}}: <span>{{moneyAll1.totalFee || ''}} {{moneyAll1.currency || 'USD'}}</span></h3>
					<li>{{langtrans().jyfy[languageIndex]}}: <span>{{moneyAll1.rescueFee}} {{moneyAll1.currency || 'USD'}}</span></li>
					<li v-if="this.$route.query.typeId != 800">{{langtrans().ajfy[languageIndex]}}: <span>{{moneyAll1.caseFee}} {{moneyAll1.currency || 'USD'}}</span></li>
					<li v-if="this.$route.query.typeId != 800">{{langtrans().ylfy[languageIndex]}}: <span>{{moneyAll1.medicFee}} {{moneyAll1.currency || 'USD'}}</span></li>
					
				</ul>
				<ul>
					<h3>B{{langtrans().sjfy[languageIndex]}}</h3>
					<h3 v-if="this.$route.query.typeId != 800">{{langtrans().ztbtbj[languageIndex]}}: <span>{{moneyAll2.totalFee || ''}} {{moneyAll2.currency || 'USD'}}</span></h3>
					<li>{{langtrans().jyfy[languageIndex]}}: <span>{{moneyAll2.rescueFee}} {{moneyAll2.currency || 'USD'}}</span></li>
					<li v-if="this.$route.query.typeId != 800">{{langtrans().ajfy[languageIndex]}}: <span>{{moneyAll2.caseFee}} {{moneyAll2.currency || 'USD'}}</span></li>
          <!-- <li v-if="this.$route.query.typeId == 800">案件服务费用: <span>{{moneyAll2.caseFee}} {{moneyAll2.currency || 'USD'}}</span></li> -->
					<li v-if="this.$route.query.typeId != 800">{{langtrans().ylfy[languageIndex]}}: <span>{{moneyAll2.medicFee}} {{moneyAll2.currency || 'USD'}}</span></li>					
					<li v-if="this.$route.query.typeId != 800">{{langtrans().qjtfy[languageIndex]}}: <span>{{moneyAll2.otherFee}} {{moneyAll1.currency || 'USD'}}</span></li>
          <li v-if="this.$route.query.typeId == 800">客户自费: <span>{{moneyAll2.medicFee}} {{moneyAll1.currency || 'USD'}}</span></li>
				</ul>
				<p class="text1"><b>{{langtrans().fybz[languageIndex]}}</b>{{languageIndex==0? setTxt(moneyAll2.otherFeeDesc,'zh'):setTxt(moneyAll2.otherFeeDesc,'en')}}</p>
			</div>
        </div>
    </div>
</template>

<script>
import langtrans from "./js/finishpar.vue.trans.js";
import "isomorphic-fetch";
import constants from '@/util/constants.js';
import Promise from 'promise-polyfill';
import ParheaderVue from "../par/parheader.vue";
import { getCasedetail,getNodeData } from '@/views/axios/api.js';
if (!window.Promise) {
  window.Promise = Promise;
}
export default {
  components: {
    ParheaderVue
  },
  data() {
    return {
      token: this.$route.params.token||
        JSON.parse(window.localStorage.getItem("data")).data,
      obj: {},
      victimList: {},
      inf: null,
      init: null,
      obj2: null,
      typeId:this.$route.query.typeId,
      caseid:this.$route.query.caseid,
      usertype: JSON.parse(window.localStorage.getItem("usertype")).data,
      finishArray:["Finish","ComFinish","RegFinish"],
      parinfArray:["Finishparinf","ComFinishparinf","RegFinishparinf"],
      parcaseArray:["Finishparcase","ComFinishparcase","RegFinishparcase"],
      stepdata:[],
      serviceFinish:'',
      num:'',
      imglist:[],
      moneyAll1:{},
      moneyAll2:{},
    };
  },
  methods: {
	setTxt(str,status){
		if(constants.setTxt(str,status)){
			return constants.setTxt(str,status)
		}else{
			return str
		}
		
	},	  
	  langtrans(){
	  	return langtrans
	  },
    back() {
      this.$router.go(-2)
    },
    up(v) {
      console.log(v);
    },
    setdata() {
      let that = this;
      that.$router.push({
        name: that.parinfArray[that.usertype],
        params: {
          token: that.token
        },
        query: {
          caseid:this.caseid,
          typeId: this.$route.query.typeId
        }
      });
    },
    getCasedetail(){
    	var data={
			token:this.token,
			caseId:this.caseid
    	}
    	getCasedetail(data)
	      .then(data => {
	      	data=data.data
	        this.init = data.obj;
	        this.obj2 = data.obj2;
	        this.moneyAll2 =data.obj.feelst[0]
	        console.log(this.moneyAll2)
	        this.setdata();
	      })
	      .catch(err => {
	      	console.log(err)
	      })
    	
    },
	getNodeData(){
		var data={
			token: this.token,
			caseId: this.caseid					
		}
		getNodeData(data)
		.then(res => {
			this.stepdata = res.data.obj2;
			this.moneyAll1 = res.data.obj;
			let n = 0;
			let arr = [];
			this.stepdata.map((v, i) => {
				arr.push(v.obj.state);
				if(v.dict.parentId != 0) {
					if(v.obj.state && v.obj.state == 1) {
						this.stid = i;
						console.log(v.obj.state);
					} else {
						this.serviceFinish = 0;
					}
				}
				if(i != 0) {
					this.imglist.push({
						list: v.uploadCntList
					});
					if(v.uploadCntList.length > 0) {
						this.num = i;
					}
				}
			});
			for(let index = 0; index < arr.length; index++) {
				if(arr[index] != 0) {} else {
					n = index + 1;
				}
			}
			if(n == 0) {
				this.btn_flag = true;
			}
			this.loading = false;
		});				
	},    
  },

		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},
  mounted() {
    this.getCasedetail();
    this.getNodeData()
  }
};
</script>

<style scoped>
@import url(../../css/par.css);
	.jiedianBox{margin-left: 35px;margin-top: 10px;}
	.jiedianBox .list{margin-bottom: 20px;margin-left: 40px;}
	.jiedianBox .list .top{overflow: hidden;}
	.jiedianBox .list .top p{float: left;margin-right: 200px;}
	.jiedianBox .list .top p.text1{color: #00abfa;margin-right: 0;margin-left: 20px;cursor: pointer;}
	.jiedianBox .list .top p.icon{background: url('./../../assets/img/checkyes.png') left center no-repeat;padding-left: 20px;}
	.jiedianBox .list .top p.iconNo{background: url('./../../assets/img/checkno.png') left center no-repeat;padding-left: 23px;}
	.jiedianBox .list .box1{margin-top: 10px;margin-left: 30px;overflow: hidden;}
	.jiedianBox .list .box1 ul{float: left;color: #999;}
	.jiedianBox .list .box1 p{float: left;line-height: 30px;}
	.jiedianBox .list .box1 li{line-height: 30px;}
	.det_box{margin-bottom: 20px;}
.addfujian li{
	background: url('../../../static/images/fj.png') no-repeat left center;
	padding-left: 20px;	
	cursor: pointer;
	margin-bottom: 10px;
	line-height: 30px;
	margin-right: 150px;
	
}
.addfujian li span{
	max-width: 200px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	display: inline-block;
	vertical-align: middle;	
}
.addfujian li.add{color: #00abfa;}
.addfujian li .delete{color: #00abfa;margin-left: 10px;text-decoration: none;}	
.baojia{padding-left: 35px;}
.baojia ul{overflow: hidden;margin-top: 20px;margin-left: 40px;}
.baojia ul *{float: left;margin-right: 10px;}
.baojia ul h3{font-size: 14px;}
.baojia ul h3:first-child{width: 100px;}
.baojia ul span{color: #ff7200;float: none;}
.baojia ul li{font-size: 14px}
.text1{margin-top: 20px;;margin-left: 153px;color: #333;font-size: 14px;}
</style>



// WEBPACK FOOTER //
// src/components/fac/finishpar.vue